import OrganisationApi from '@packages/organisations/api';

export class CustodianApi extends OrganisationApi {
    static resource = 'custodians';
}

export default CustodianApi;
